import React from 'react';

const ChartContainer = ({ title, children }) => (
    <div className="bg-white rounded py-4 pe-2 realEstateChartContainer">
        <h2 className="fs-5 scoutDashboardCardTitle ms-4 mb-2">{title}</h2>
        <div style={{ height: '300px' }}>{children}</div>
    </div>
);

export default ChartContainer;
